<template>
  <el-row>
    <el-col :span="24">
      <h3 class="form-title">PSIT</h3>
    </el-col>
    <el-col :span="24" v-loading="loading">
      <div class="fs-sections">
        <div
          v-for="section in sections"
          :key="section.type"
          class="fs-section-card"
        >
          <h4 class="fs-section-title">{{ section.label }}</h4>

          <div v-if="filesMap[section.type]" class="fs-file-row">
            <div class="fs-file-info">
              <span class="fs-file-name">{{
                filesMap[section.type].file_name
              }}</span>
              <el-tag size="small" type="info">
                .{{ filesMap[section.type].file_extension }}
              </el-tag>
            </div>
            <div class="fs-file-actions">
              <el-button
                type="primary"
                @click="downloadFile(filesMap[section.type])"
              >
                Yuklab olish
              </el-button>
              <input
                type="file"
                :ref="(el) => setInputRef(el, section.type)"
                hidden
                :accept="section.accept"
                @change="(e) => uploadAndSave(e, section.type)"
              />
              <el-button
                :loading="saving[section.type]"
                @click="triggerUpload(section.type)"
              >
                Almashtirish
              </el-button>
            </div>
          </div>

          <div v-else class="fs-empty-row">
            <span class="fs-empty-text">Fayl yuklanmagan</span>
            <input
              type="file"
              :ref="(el) => setInputRef(el, section.type)"
              hidden
              :accept="section.accept"
              @change="(e) => uploadAndSave(e, section.type)"
            />
            <el-button
              type="primary"
              :loading="saving[section.type]"
              @click="triggerUpload(section.type)"
            >
              Fayl yuklash
            </el-button>
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { ElMessage } from "element-plus";
import http from "@/http";
import store from "@/store";

const sections = [
  { type: "PSIT_METADATA", label: "Metadata", accept: ".pdf" },
  { type: "PUBLIC_SECTOR_DIAGRAM", label: "Public sector diagram", accept: "" },
];

const loading = ref(false);
const filesMap = reactive({});
const saving = reactive({ PSIT_METADATA: false, PUBLIC_SECTOR_DIAGRAM: false });
const inputRefs = {};

const FILE_URL = process.env.VUE_APP_BASE_API_URL + "api/v2/info/file/";

const setInputRef = (el, type) => {
  if (el) inputRefs[type] = el;
};

const triggerUpload = (type) => {
  inputRefs[type]?.click();
};

const fetchFiles = () => {
  loading.value = true;
  http
    .get("api/v1/financial-statistic-psit")
    .then(({ data }) => {
      data.forEach((item) => {
        filesMap[item.type] = item;
      });
    })
    .catch(() => {
      ElMessage.error("Ma'lumot olishda xatolik");
    })
    .finally(() => {
      loading.value = false;
    });
};

const downloadFile = (file) => {
  const link = document.createElement("a");
  link.href = FILE_URL + file.file_id;
  link.setAttribute("download", file.file_name || file.file_id);
  link.target = "_blank";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const uploadAndSave = (event, type) => {
  const file = event.target.files[0];
  if (!file) return;
  if (file.size / 1024 / 1024 > 20) {
    ElMessage.error("Fayl xajmi max. 20MB bo'lishi kerak!");
    event.target.value = "";
    return;
  }
  const formData = new FormData();
  formData.append("file", file);
  saving[type] = true;
  http
    .post(`${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`, formData, {
      headers: {
        Authorization: store.state.accessToken,
        "Content-Type": "multipart/form-data",
      },
    })
    .then(({ data }) => {
      return http({
        url: "api/v1/financial-statistic-psit",
        method: "put",
        data: { type, file_id: data.hashId },
      });
    })
    .then(({ data }) => {
      filesMap[type] = data;
      ElMessage.success("Muvaffaqqiyatli saqlandi");
    })
    .catch(() => {
      ElMessage.error("Saqlashda xatolik. Qayta urinib ko'ring!");
    })
    .finally(() => {
      saving[type] = false;
      event.target.value = "";
    });
};

onMounted(fetchFiles);
</script>

<style scoped lang="scss">
.fs-sections {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.fs-section-card {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 24px;
}

.fs-section-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  margin: 0 0 16px;
}

.fs-file-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.fs-file-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.fs-file-name {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}

.fs-file-actions {
  display: flex;
  gap: 8px;
}

.fs-empty-row {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #909399;
}

.fs-empty-text {
  font-size: 14px;
}
</style>
